module.exports = __webpack_public_path__ + "img/s2-img2.512f04b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s2-img2.png
// module id = 408
// module chunks = 0